"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Body = void 0;

var _tokens = require("@superlogica/foundation/tokens");

var _polished = require("polished");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var Body = _styledComponents.default.p.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['tag', 'color', 'margin', 'isTitle', 'size', 'align', 'weight'].includes(prop);
  }
}).withConfig({
  componentId: "sc-12w7q7i-0"
})(["position:relative;", ""], function (_ref) {
  var align = _ref.align,
      color = _ref.color,
      isTitle = _ref.isTitle,
      theme = _ref.theme,
      size = _ref.size,
      weight = _ref.weight;
  return "\n    text-align: ".concat(align, ";\n    color: ").concat(_tokens.colors[theme.colors[color].color + theme.colors[color].scale], ";\n    font-family: '").concat(isTitle ? theme.fonts.headings : theme.fonts.default, "', sans-serif;\n    font-weight: ").concat(weight ? _tokens.fontWeight[weight] : _tokens.fontWeight.normal, ";\n    font-size: ").concat(theme.typography[size].mobile ? (0, _polished.between)("".concat(theme.typography[size].mobile.fontSize, "px"), "".concat(theme.typography[size].desktop.fontSize, "px"), '320px', '1400px') : "".concat(theme.typography[size].desktop.fontSize, "px"), ";\n    line-height: ").concat(theme.typography[size].mobile ? (0, _polished.between)("".concat(theme.typography[size].mobile.lineHeight, "px"), "".concat(theme.typography[size].desktop.lineHeight, "px"), '320px', '1400px') : "".concat(theme.typography[size].desktop.lineHeight, "px"), ";\n ");
});

exports.Body = Body;